export default __webpack_public_path__ + "static/media/logo-glygen-blue-36.ff5bcaf7.svg";